export default __webpack_public_path__ + "18dfe54d4ec55497b01c323196c572cb.mp3";